import { createFileRoute, Outlet } from "@tanstack/react-router";
import React from "react";
import {
  Award,
  Bell,
  Building2,
  ClipboardCheck,
  HelpCircle,
  LayoutDashboard,
  ListChecks,
  MessageSquareQuote,
  ShieldCheck,
  Trophy,
  Users,
} from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import type { SidebarItem } from "@/components/layout/Sidebar";
import { requireRole } from "@/lib/route-guards";

export const Route = createFileRoute("/partner")({
  beforeLoad: () => requireRole(["partner"]),
  component: PartnerLayout,
});

const sidebarItems: SidebarItem[] = [
  {
    label: "Dashboard",
    path: "/partner/dashboard",
    icon: <LayoutDashboard size={20} />,
    section: "Overview",
  },
  {
    label: "Placement Slots",
    path: "/partner/slots",
    icon: <ListChecks size={20} />,
    section: "Operations",
  },
  {
    label: "Assigned Students",
    path: "/partner/students",
    icon: <Users size={20} />,
    section: "Operations",
  },
  {
    label: "Work Log Reviews",
    path: "/partner/work-logs",
    icon: <ClipboardCheck size={20} />,
    section: "Operations",
  },
  {
    label: "Assessments",
    path: "/partner/assessments",
    icon: <Trophy size={20} />,
    section: "Operations",
  },
  {
    label: "Verify Experience",
    path: "/partner/verification",
    icon: <ShieldCheck size={20} />,
    section: "Operations",
  },
  {
    label: "Recommendations",
    path: "/partner/recommendations",
    icon: <MessageSquareQuote size={20} />,
    section: "Talent",
  },
  {
    label: "Notifications",
    path: "/partner/notifications",
    icon: <Bell size={20} />,
    section: "Account",
  },
  {
    label: "Send Tips",
    path: "/partner/tips",
    icon: <Award size={20} />,
    section: "Account",
  },
  {
    label: "Help & Support",
    path: "/partner/support",
    icon: <HelpCircle size={20} />,
    section: "Account",
  },
  {
    label: "Company Profile",
    path: "/partner/profile",
    icon: <Building2 size={20} />,
    section: "Account",
  },
];

function PartnerLayout() {
  return (
    <DashboardLayout title="Partner Portal" sidebarItems={sidebarItems}>
      <Outlet />
    </DashboardLayout>
  );
}
